import StitchUserProfileImpl from "./StitchUserProfileImpl";

var CoreStitchUserImpl = function () {
  function CoreStitchUserImpl(id, loggedInProviderType, loggedInProviderName, isLoggedIn, lastAuthActivity, profile, customData) {
    this.id = id;
    this.loggedInProviderType = loggedInProviderType;
    this.loggedInProviderName = loggedInProviderName;
    this.profile = profile === undefined ? StitchUserProfileImpl.empty() : profile;
    this.isLoggedIn = isLoggedIn;
    this.lastAuthActivity = lastAuthActivity;
    this.customData = customData === undefined ? {} : customData;
  }

  Object.defineProperty(CoreStitchUserImpl.prototype, "userType", {
    get: function get() {
      return this.profile.userType;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CoreStitchUserImpl.prototype, "identities", {
    get: function get() {
      return this.profile.identities;
    },
    enumerable: true,
    configurable: true
  });

  CoreStitchUserImpl.prototype.equals = function (other) {
    return this.id === other.id && JSON.stringify(this.identities) === JSON.stringify(other.identities) && this.isLoggedIn === other.isLoggedIn && this.loggedInProviderName === other.loggedInProviderName && this.loggedInProviderType === other.loggedInProviderType && JSON.stringify(this.profile) === JSON.stringify(other.profile);
  };

  return CoreStitchUserImpl;
}();

export default CoreStitchUserImpl;